import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TOAST_OPTIONS = {
  position: "top-center",
  autoClose: 3000,
};

const TOAST_IDS = {
  success: "global-toast-success",
  error: "global-toast-error",
  info: "global-toast-info",
  warning: "global-toast-warning",
};

const normalizeMessage = (message) => {
  if (message == null || message === "") return "";
  return String(message);
};

const showToast = (type, message) => {
  const text = normalizeMessage(message);
  if (!text) return;
  const toastId = TOAST_IDS[type] ?? TOAST_IDS.info;
  toast.dismiss(toastId);
  toast[type](text, { ...TOAST_OPTIONS, toastId });
};

class ToasterMsg {
  success = (message) => {
    showToast("success", message);
  };

  error = (message) => {
    showToast("error", message);
  };

  info = (message) => {
    showToast("info", message);
  };

  warning = (message) => {
    showToast("warning", message);
  };
}

export const toastMsg = new ToasterMsg();

class Toaster {
  waitingPromis = async (callBackFuction, pendingMsg, successMsg) => {
    const options = {
      pending: pendingMsg,
      success: successMsg,
      error: {
        render({ data }) {
          return `${data?.message}`;
        },
      },
    };
    await toast.promise(callBackFuction, options);
  };

  error = (message) => {};
}

export const toastAlert = new Toaster();
